// ネイティブチェック済みの確定文言。表記の揺れを持ち込まないため書き換えない
export const CAPACITY_NOTICE = 'If your group exceeds the maximum capacity shown, please split your group and make separate bookings.';
